import { render, staticRenderFns } from "./EmptySection.vue?vue&type=template&id=a1b7f698&"
import script from "./EmptySection.vue?vue&type=script&setup=true&lang=js&"
export * from "./EmptySection.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports